import { render, staticRenderFns } from "./SliderImage.vue?vue&type=template&id=e040518c&scoped=true&"
import script from "./SliderImage.vue?vue&type=script&lang=js&"
export * from "./SliderImage.vue?vue&type=script&lang=js&"
import style0 from "./SliderImage.vue?vue&type=style&index=0&id=e040518c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e040518c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCarousel,VCarouselItem,VRow,VSheet})
